var exports = {
  "Ze": "AddFriendView.module__friendRequestContainer___U0lNbW",
  "Nr": "AddFriendView.module__card___U0lNbW",
  "Og": "AddFriendView.module__heroIcon___U0lNbW",
  "DD": "AddFriendView.module__title___U0lNbW",
  "VA": "AddFriendView.module__subtitle___U0lNbW",
  "KJ": "AddFriendView.module__formContainer___U0lNbW",
};

module.exports = exports;
